function arrify(val) {
  return Array.isArray(val) ? val : [val];
}
export {
  arrify
};
//# sourceMappingURL=arrify.js.map
